/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';

import {
  Components, DaysOfWeek, DorMeasurementFieldNames,
  DorPlaceStatus, MeasurementDisplayTypes, StaticProfiles,
} from '@powdr/constants';
import { usePlaceStatus } from '@powdr/hooks';
import {
  capitalizeAllWords, deslugify, formatDate, getDorStatusColor,
} from '@powdr/utils';

import { CircularGraph } from './circular-graph';
import {
  CircularGraphInnerTextOverride,
} from './styles';
import { TextHours } from './text-hours';
import { TextMeasurement } from './text-measurement';

export const RetailServiceStatus = ({
  measurementDisplayType = null,
  parentColorProfile = null,
  measurementLabel = null,
  retailService = null,
  icon = null,
}) => {
  const measurementData = usePlaceStatus(retailService?.uuid || null);
  const getColorOverride = (value) => getDorStatusColor(
    DorPlaceStatus,
    value,
    Components.DOR_MEASUREMENTS,
    StaticProfiles.ALERTS,
  );
  const status = measurementData?.[DorMeasurementFieldNames.STATUS] || null;
  const hoursArr = (measurementData?.[DorMeasurementFieldNames.HOURS]?.length > 0)
    ? measurementData?.[DorMeasurementFieldNames.HOURS]
    : null;

  if (!measurementData || !status) return null;

  const getCurrentHoursStrings = () => {
    const d = new Date();
    const dayOfWeekCurrent = Object.values(DaysOfWeek)[d.getDay()].toLowerCase();
    const todayHours = hoursArr?.filter((h) => h.day === dayOfWeekCurrent) || null;

    return (todayHours) ? todayHours.map((h) => {
      const today = new Date();

      const open = formatDate(new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        Math.floor(h.open / 100),
        h.open % 100,
      ));

      const close = formatDate(new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        Math.floor(h.close / 100),
        h.close % 100,
      ));

      return `${open.time.hours}:${open.time.minutes} ${open.time.ampm} - ${close.time.hours}:${close.time.minutes} ${close.time.ampm}`;
    }) : null;
  };

  return (
    <>
      {(measurementDisplayType === MeasurementDisplayTypes.CIRCULAR_GRAPH) && (
        <CircularGraph
          colorProfile={parentColorProfile}
          label={measurementLabel}
          colorOverride={getColorOverride(status)}
        >
          <CircularGraphInnerTextOverride className="inner-content">
            {capitalizeAllWords(deslugify(status))}
          </CircularGraphInnerTextOverride>
        </CircularGraph>
      )}
      {(measurementDisplayType === MeasurementDisplayTypes.TEXT
        || measurementDisplayType === MeasurementDisplayTypes.TEXT_LARGE) && (
        <TextMeasurement
          measurementDisplayType={measurementDisplayType}
          label={measurementLabel}
          icon={icon}
          colorProfile={parentColorProfile}
          colorOverride={getColorOverride(status)}
          small
        >
          {capitalizeAllWords(deslugify(status))}
        </TextMeasurement>
      )}
      {(measurementDisplayType === MeasurementDisplayTypes.TEXT_HOURS) && (
        <TextHours
          label={measurementLabel}
          icon={icon}
          colorProfile={parentColorProfile}
          colorOverride={getColorOverride(status)}
          small
          status={status}
          hours={getCurrentHoursStrings()}
        />
      )}
    </>
  );
};

RetailServiceStatus.propTypes = {
  parentColorProfile: PropTypes.string,
  measurementLabel: PropTypes.string,
  measurementDisplayType: PropTypes.string,
  icon: PropTypes.string,
  retailService: PropTypes.shape({
    value: PropTypes.string,
    uuid: PropTypes.string,
  }),
};
